module.exports = new __parcel__URL__("step-teams-concept.3ee797f6.svg").toString();